import { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";

const noop = () => {};

export default function AwardsAndAffiliationsOverlay({
  isOpen = false,
  item = null,
  onClose = noop,
}) {
  const [activeItem, setActiveItem] = useState(item);

  useEffect(() => {
    if (item) {
      setActiveItem(item);
    }
  }, [item]);

  const hasContent = Boolean(
    activeItem && (activeItem.type || activeItem.logoHTML || activeItem.title || activeItem.body)
  );

  return (
    <Transition
      show={isOpen && hasContent}
      as={Fragment}
      appear
      afterLeave={() => setActiveItem(null)}
    >
      <Dialog
        as="div"
        className="b-awards-and-affiliations__overlay"
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-smooth duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-smooth duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className="b-awards-and-affiliations__overlay-backdrop"
            aria-hidden="true"
          />
        </Transition.Child>

        <div className="b-awards-and-affiliations__overlay-wrapper">
          <Transition.Child
            as={Fragment}
            enter="ease-smooth duration-500"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-smooth duration-500"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <Dialog.Panel className="b-awards-and-affiliations__overlay-panel">
              <button
                type="button"
                className="b-awards-and-affiliations__overlay-close"
                onClick={onClose}
                aria-label="Close details"
              >
                <span aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" fill="none" viewBox="0 0 16 15"><path stroke="#000" strokeWidth="2" d="m1.119.707 13.435 13.435M14.142.707.707 14.142"/></svg>
                </span>
              </button>

              {activeItem?.logoHTML ? (
                <div
                  className="b-awards-and-affiliations__overlay-logo"
                  dangerouslySetInnerHTML={{ __html: activeItem.logoHTML }}
                />
              ) : null}

              <div className="b-awards-and-affiliations__overlay-text">

                {activeItem?.type ? (
                  <span className="b-awards-and-affiliations__overlay-type">
                    {activeItem.type}
                  </span>
                ) : null}

                {activeItem?.title ? (
                  <Dialog.Title className="b-awards-and-affiliations__overlay-title">
                    {activeItem.title}
                  </Dialog.Title>
                ) : null}

                {activeItem?.body ? (
                  <div
                    className="b-awards-and-affiliations__overlay-body"
                    dangerouslySetInnerHTML={{ __html: activeItem.body }}
                  />
                ) : null}
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
